import React, { Suspense } from 'react';
import {createRoot} from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
const DistroPlotApp = React.lazy(() => import('./DistroPlot'));
const DashboardApp = React.lazy(() => import('./dashboard/Dashboard'));
const App = process.env.REACT_APP_MODE === 'dashboard' ? DashboardApp : DistroPlotApp

createRoot(document.getElementById('root')).render(
    // StrictMode is currently incompatible with Redux (version 7.2.5)
    // Fixed by https://github.com/reduxjs/react-redux/pull/1817
    <Suspense fallback={<div>Loading...</div>}>
        <App />
    </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
